import React from "react";

const BackgroundImage = ({ showBgImage, bgImageSrc, videoClassName }) => {
  if (!showBgImage || !bgImageSrc) {
    return null;
  }

  return (
    <img
      className={videoClassName}
      alt=" "
      src={bgImageSrc}
      style={{
        objectFit: "cover",
        objectPosition: "center center",
        opacity: "0.4",
        position: "absolute",
      }}
    />
  );
};

export default BackgroundImage;
